export default __webpack_public_path__ + "static/media/delete-forever.760530c6.svg";